var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHour = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partnergram-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.05.1_Location---Details",
    transform: "translate(-225.000000, -65.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subnavigation-/-Events-/-1st",
    transform: "translate(0.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(225.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 1.4,
    cx: 12,
    cy: 12,
    r: 11.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4.61538462,
    x2: 12,
    y2: 12,
    id: "Line-3",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5384615,
    y1: 12,
    x2: 12,
    y2: 12,
    id: "Line-3-Copy",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHour, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hour.8c10aea7.svg";
export { ForwardRef as ReactComponent };